

import Vue from 'vue'
import { assetURL } from '@/utils'

const taxReceiptTransformer = (data) => {
  const { xml_file: xmlFile, pdf_file: pdfFile, status, ...rest } = data
  return {
    xmlFile: assetURL(xmlFile),
    pdfFile: assetURL(pdfFile),
    status: status ? status.name : "NO STATUS",
    ...rest,
  }
}

export default (affectedId) => {
  return new Promise((resolve, reject) => {
    Vue.$http.get(`/taxreceipt/invoice-of-sinister/${affectedId}/`, affectedId)
      .then(({ data }) => {
        resolve(data.map(t => taxReceiptTransformer(t.cfdi)))
      }).catch(err => {
        const status = err.response && err.response.status
        const notFound = status === 404
        resolve(null)
      })
    })
}


// WEBPACK FOOTER //
// ./src/services/taxReceipt/fetchSinisterTaxReceipt.js